/* NoriaHealth, welcome form block, render and submission engine.
   Two ways in at the top, Sign in with Google on the left, WhatsApp on the
   right. Below, a short form where only email and the main reason are
   required, everything else is optional.
   Any of these events reaches the same CRM intake relay on Infomaniak,
   which creates or enriches the Lead in SuiteCRM and notifies hub@.
   Conversion tracking feeds the theme GA4 dataLayer only.
*/

(function () {
  "use strict";

  var cfgEl = document.getElementById("noria-accueil-config");
  var root = document.getElementById("noria-accueil-app");
  if (!cfgEl || !root) return;

  var CFG = JSON.parse(cfgEl.textContent);
  var params = new URLSearchParams(window.location.search);

  // UTM tags captured in the background, invisible to the prospect.
  var UTM = {
    utm_source: params.get("utm_source") || null,
    utm_medium: params.get("utm_medium") || null,
    utm_campaign: params.get("utm_campaign") || null,
    utm_content: params.get("utm_content") || null,
    utm_term: params.get("utm_term") || null,
    referrer: document.referrer || null,
    landing_page: window.location.pathname || null,
  };

  var state = { form: null, answers: {}, submitted: false, googleEmail: null, reference: null, crmId: null, carePath: "assessment", liveDoctorAvailable: false, liveDoctorStatusLoaded: false, liveDoctorMessage: "", whatsappAvailable: false, whatsappStatusLoaded: false, whatsappMessage: "" };

  /* ----------------------------------------------------------------
     Conversion tracking, theme GA4 dataLayer only.
  ---------------------------------------------------------------- */
  var TRACK = { sessionId: null, started: false, submitted: false, abandonSent: false, viewSent: false };

  function getSessionId() {
    if (TRACK.sessionId) return TRACK.sessionId;
    var key = "noria_accueil_sid";
    var sid = null;
    try { sid = window.sessionStorage.getItem(key); } catch (e) {}
    if (!sid) {
      sid = "S-" + Date.now().toString(36).toUpperCase() + "-" +
        Math.random().toString(36).slice(2, 8).toUpperCase();
      try { window.sessionStorage.setItem(key, sid); } catch (e) {}
    }
    TRACK.sessionId = sid;
    return sid;
  }

  // Reference stable for the whole session, shared by the Google event and
  // the form event, so a single prospect keeps one reference in the CRM.
  function getReference() {
    if (state.reference) return state.reference;
    var key = "noria_accueil_ref";
    var r = null;
    try { r = window.sessionStorage.getItem(key); } catch (e) {}
    if (!r) {
      r = "NH-" + Date.now().toString(36).toUpperCase() + "-" +
        Math.random().toString(36).slice(2, 6).toUpperCase();
      try { window.sessionStorage.setItem(key, r); } catch (e) {}
    }
    state.reference = r;
    return r;
  }

  function fieldsFilled() {
    var required = ["email", "category", "first_name", "last_name", "phone", "country"];
    var n = 0;
    required.forEach(function (k) {
      var v = state.answers[k];
      if (v && String(v).trim() !== "") n++;
    });
    return { filled: n, total: required.length, percent: Math.round((n / required.length) * 100) };
  }

  function track(eventName, extra) {
    var progress = fieldsFilled();
    try {
      window.dataLayer = window.dataLayer || [];
      var evt = {
        event: "noria_" + eventName,
        noria_session_id: getSessionId(),
        noria_utm_source: UTM.utm_source,
        noria_utm_medium: UTM.utm_medium,
        noria_utm_campaign: UTM.utm_campaign,
        noria_utm_content: UTM.utm_content,
        noria_progress_percent: progress.percent
      };
      if (extra) { for (var k in extra) { if (extra.hasOwnProperty(k)) evt["noria_" + k] = extra[k]; } }
      window.dataLayer.push(evt);
    } catch (e) {}
  }

  function markStarted() {
    if (TRACK.started) return;
    TRACK.started = true;
    track("form_start", null);
  }

  function maybeAbandon() {
    if (TRACK.abandonSent) return;
    if (!TRACK.started || TRACK.submitted) return;
    TRACK.abandonSent = true;
    track("form_abandon", { reason: "page_quittee" });
  }

  // Depart de la page. Si un email a ete saisi ou fourni par Google et que
  // le formulaire n'a pas ete envoye, on notifie hub@ une seule fois, de
  // maniere fiable avec sendBeacon, meme pendant la fermeture de la page.
  function sendAbandonBeacon() {
    if (state.abandonBeaconed) return;
    if (state.submitted) return;
    if (!emailValid()) return;
    state.abandonBeaconed = true;
    var payload = buildPayload();
    payload.notify = false;
    payload.notify_reason = "abandon";
    try {
      var blob = new Blob([JSON.stringify(payload)], { type: "text/plain;charset=UTF-8" });
      if (navigator.sendBeacon) {
        navigator.sendBeacon(CFG.intake_url, blob);
      }
    } catch (e) {}
  }

  function onLeave() {
    maybeAbandon();
    sendAbandonBeacon();
  }
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") onLeave();
  });
  window.addEventListener("pagehide", onLeave);

  var COUNTRIES = [
    "Belgium", "France", "Luxembourg", "Netherlands", "Germany", "Switzerland",
    "United Kingdom", "Spain", "Italy", "Portugal", "Austria", "Ireland",
    "Denmark", "Sweden", "Norway", "Poland", "Romania", "Greece",
    "United Arab Emirates", "Saudi Arabia", "Qatar", "Kuwait",
    "United States", "Canada", "Morocco", "Algeria", "Tunisia", "Other"
  ];

  var WA_ICON = '<svg width="17" height="17" viewBox="0 0 24 24" fill="#fff" aria-hidden="true">' +
    '<path d="M17.5 14.4c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.77-.72 2.02-1.42.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35zM12 2C6.48 2 2 6.48 2 12c0 1.76.46 3.42 1.27 4.86L2 22l5.25-1.38A9.94 9.94 0 0012 22c5.52 0 10-4.48 10-10S17.52 2 12 2z"/></svg>';

  // Load the JSON to get the C.02 categories and the module mapping.
  fetch(CFG.form_json_url)
    .then(function (r) { return r.json(); })
    .then(function (data) {
      state.form = data;
      preFillCustomer();
      render();
      loadLiveDoctorAvailability();
      loadWhatsAppAvailability();
      track("form_view", null);
      TRACK.viewSent = true;
    })
    .catch(function (err) {
      root.innerHTML = '<p class="noria-accueil-error">Loading error. You can email us at hub@noriahealth.com.</p>';
      console.error(err);
    });

  function preFillCustomer() {
    var c = CFG.logged_in_customer;
    if (!c) return;
    if (c.first_name) state.answers.first_name = c.first_name;
    if (c.last_name) state.answers.last_name = c.last_name;
    if (c.email) state.answers.email = c.email;
    if (c.phone) state.answers.phone = c.phone;
  }

  function getC02Choices() {
    if (!state.form) return [];
    var all = [];
    state.form.sections.forEach(function (s) {
      s.questions.forEach(function (q) { if (q.code === "C.02") all = q.choices; });
    });
    return all;
  }

  /* ----------------------------------------------------------------
     Sign in with Google, on-page identity, prefills email and name.
     The signed token is verified server side by the relay.
  ---------------------------------------------------------------- */
  function loadGsi(cb) {
    if (window.google && google.accounts && google.accounts.id) return cb(true);
    if (document.getElementById("gsi-lib")) {
      var t = setInterval(function () {
        if (window.google && google.accounts && google.accounts.id) { clearInterval(t); cb(true); }
      }, 200);
      setTimeout(function () { clearInterval(t); cb(!!(window.google && google.accounts && google.accounts.id)); }, 4000);
      return;
    }
    var s = document.createElement("script");
    s.id = "gsi-lib";
    s.src = "https://accounts.google.com/gsi/client";
    s.async = true; s.defer = true;
    s.onload = function () { cb(true); };
    s.onerror = function () { cb(false); };
    document.head.appendChild(s);
  }

  function initGoogle(container) {
    loadGsi(function (ok) {
      if (!ok || !(window.google && google.accounts && google.accounts.id)) {
        container.style.display = "none";
        return;
      }
      google.accounts.id.initialize({
        client_id: CFG.google_client_id,
        callback: onGoogleCredential,
        ux_mode: "popup"
      });
      var w = Math.min(400, Math.max(200, container.clientWidth || 240));
      google.accounts.id.renderButton(container, {
        type: "standard", theme: "outline", size: "large",
        text: "signin_with", shape: "rectangular", logo_alignment: "left", width: w
      });
    });
  }

  function decodeJwt(t) {
    try {
      var parts = String(t).split(".");
      if (parts.length < 2) return null;
      var b = parts[1].replace(/-/g, "+").replace(/_/g, "/");
      var pad = b.length % 4;
      if (pad) b += new Array(5 - pad).join("=");
      var json = decodeURIComponent(atob(b).split("").map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(""));
      return JSON.parse(json);
    } catch (e) { return null; }
  }

  function onGoogleCredential(resp) {
    var cred = resp && resp.credential;
    if (!cred) return;
    var p = decodeJwt(cred);
    if (p) {
      if (p.email) state.answers.email = p.email;
      if (p.given_name && !state.answers.first_name) state.answers.first_name = p.given_name;
      if (p.family_name && !state.answers.last_name) state.answers.last_name = p.family_name;
      state.googleEmail = p.email || null;
    }
    markStarted();
    sendGoogleEvent(cred).then(function () {
      // Persiste sur la meme ligne les champs deja choisis avant la connexion.
      scheduleCrmSync({ immediate: true, force: true });
    });
    render();
  }

  function sendGoogleEvent(cred) {
    var payload = {
      event: "google_signin",
      reference: getReference(),
      session_id: getSessionId(),
      submitted_at: new Date().toISOString(),
      google_credential: cred,
      source: { shop_domain: CFG.shop_domain, landing_page: UTM.landing_page, referrer: UTM.referrer },
      utm: {
        source: UTM.utm_source, medium: UTM.utm_medium, campaign: UTM.utm_campaign,
        content: UTM.utm_content, term: UTM.utm_term
      },
      // The relay reads the verified email from the signed token, not from here.
      lead: {
        email: null,
        first_name: state.answers.first_name || null,
        last_name: state.answers.last_name || null
      }
    };
    return fetch(CFG.intake_url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      mode: "cors"
    })
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        try { var d = JSON.parse(txt); if (d && d.crm_id) state.crmId = d.crm_id; } catch (e) {}
        track("google_signin", null);
      })
      .catch(function (e) { track("google_signin_error", { http_error: String(e && e.message || e) }); });
  }

  function whatsappButton() {
    var a = document.createElement("a");
    a.className = "noria-accueil-wa";
    var num = String(CFG.whatsapp_number || "").replace(/[^0-9]/g, "");
    var txt = CFG.whatsapp_text || "Hello, I would like a medical opinion.";
    a.href = "https://wa.me/" + num + "?text=" + encodeURIComponent(txt);
    a.target = "_blank";
    a.rel = "noopener";
    a.innerHTML = WA_ICON + "<span>WhatsApp us</span>";
    a.addEventListener("click", function () { track("whatsapp_click", null); });
    return a;
  }

  /* ----------------------------------------------------------------
     Render
  ---------------------------------------------------------------- */
  function loadWhatsAppAvailability() {
      fetch("https://n8n.noriahealth.com/webhook/noria-whatsapp-status-robust", { cache: "no-store" })
        .then(function (r) { if (!r.ok) throw new Error("status"); return r.json(); })
        .then(function (data) {
          state.whatsappAvailable = data.available === true;
          state.whatsappMessage = data.message || "";
          state.whatsappStatusLoaded = true;
          updateWhatsAppButton();
        })
        .catch(function () {
          state.whatsappAvailable = false;
          state.whatsappMessage = "WhatsApp is currently unavailable.";
          state.whatsappStatusLoaded = true;
          updateWhatsAppButton();
        });
    }
  
    function loadLiveDoctorAvailability() {
      fetch("https://n8n.noriahealth.com/webhook/noria-live-doctor-status", { cache: "no-store" })
        .then(function (r) { if (!r.ok) throw new Error("status"); return r.json(); })
        .then(function (data) {
          state.liveDoctorAvailable = data.available === true;
          state.liveDoctorMessage = data.message || "";
          state.liveDoctorStatusLoaded = true;
          updateLiveDoctorButton();
        })
        .catch(function () {
          state.liveDoctorAvailable = false;
          state.liveDoctorMessage = "Live doctor consultations are temporarily unavailable. Please leave your email and we will contact you as soon as possible.";
          state.liveDoctorStatusLoaded = true;
          updateLiveDoctorButton();
        });
    }
  
    function carePathChooser() {
    var wrap = document.createElement("section");
    wrap.className = "noria-care-paths";
    wrap.style.cssText = "margin:24px 0;padding:22px;border:1px solid rgba(18,55,74,.18);border-radius:14px;background:#f7fbfc";

    var title = document.createElement("h3");
    title.textContent = "Choose how you would like us to help";
    title.style.margin = "0 0 8px";
    wrap.appendChild(title);

    var intro = document.createElement("p");
    intro.textContent = "Enter one email address above. It is saved securely in our care system and used for the option you choose below.";
    intro.style.margin = "0 0 18px";
    wrap.appendChild(intro);

    var grid = document.createElement("div");
    grid.style.cssText = "display:grid;grid-template-columns:repeat(auto-fit,minmax(210px,1fr));gap:12px";

    var assessment = document.createElement("button");
    assessment.type = "button";
    assessment.className = "button button--secondary";
    assessment.textContent = "Request a medical assessment";
    assessment.addEventListener("click", function () {
      state.carePath = "assessment";
      scheduleCrmSync({ immediate: true, force: true });
      var category = document.getElementById("f-category");
      if (category) category.focus();
    });
    grid.appendChild(assessment);

    var wa = whatsappButton();
    wa.id = "noria-whatsapp-choice";
    wa.dataset.originalHref = wa.getAttribute("href") || "";
    wa.innerHTML = WA_ICON + "<span>Chat with us on WhatsApp</span>";
    wa.title = "Appointments and administrative support only. Do not send medical documents or sensitive health information through WhatsApp.";
    wa.addEventListener("click", function (event) { if (!state.whatsappAvailable) { event.preventDefault(); event.stopImmediatePropagation(); } }, true);
    grid.appendChild(wa);

    var live = document.createElement("button");
    live.type = "button";
    live.id = "noria-live-doctor-choice";
    live.className = "button button--primary";
    live.style.cssText = "grid-column:1 / -1;margin-top:14px;width:100%;font-weight:750;transition:background .2s,color .2s,border-color .2s";
    live.textContent = "Talk to a doctor by live video";
    live.disabled = true;
    live.addEventListener("click", function () {
      if (!state.liveDoctorStatusLoaded || !state.liveDoctorAvailable) { updateLiveDoctorButton(); return; }
      if (!emailValid()) {
        var email = document.getElementById("f-email");
        if (email) { email.classList.add("has-error"); email.focus(); }
        return;
      }
      state.carePath = "urgent_live_doctor";
      try {
        sessionStorage.setItem("noria_live_doctor_email", state.answers.email);
        sessionStorage.setItem("noria_live_doctor_reference", getReference());
      } catch (e) {}
      live.disabled = true;
      live.textContent = "Saving your request…";
      scheduleCrmSync({ immediate: true, force: true });
      setTimeout(function () { window.location.href = "/products/live-urgent-doctor-meeting"; }, 900);
    });
    grid.appendChild(live);
    wrap.appendChild(grid);

    var whatsappAvailability = document.createElement("p");
    whatsappAvailability.id = "noria-whatsapp-availability";
    whatsappAvailability.setAttribute("role", "status");
    whatsappAvailability.style.cssText = "grid-column:1 / -1;margin:2px 0 0;color:#9b2c2c;font-weight:650;text-align:left";
    grid.insertBefore(whatsappAvailability, live);
    updateWhatsAppButton();

    var note = document.createElement("p");
    note.style.cssText = "margin:14px 0 0;font-size:.92em";
    note.textContent = "For live video, your email is required to continue and to receive secure consultation updates. Payment details are entered only in checkout.";
    wrap.appendChild(note);
    var availability = document.createElement("p");
    availability.id = "noria-live-doctor-availability";
    availability.setAttribute("role", "status");
    availability.style.cssText = "margin:10px 0 0;color:#9b2c2c;font-weight:650";
    wrap.appendChild(availability);
    updateLiveDoctorButton();
    return wrap;
  }

  function updateWhatsAppButton() {
      var wa = document.getElementById("noria-whatsapp-choice");
      if (!wa) return;
      var enabled = state.whatsappStatusLoaded && state.whatsappAvailable;
      wa.setAttribute("aria-disabled", enabled ? "false" : "true");
      wa.style.pointerEvents = enabled ? "" : "none";
      wa.style.background = enabled ? "" : "#d7dde3";
      wa.style.borderColor = enabled ? "" : "#c8cfd7";
      wa.style.color = enabled ? "" : "#667085";
      wa.style.opacity = "1";
      if (enabled) { wa.setAttribute("href", wa.dataset.originalHref || "#"); wa.removeAttribute("tabindex"); }
      else { wa.removeAttribute("href"); wa.setAttribute("tabindex", "-1"); }
      var message = document.getElementById("noria-whatsapp-availability");
      if (message) message.textContent = state.whatsappStatusLoaded && !state.whatsappAvailable ? (state.whatsappMessage || "WhatsApp is currently unavailable.") : "";
    }
  
    function updateLiveDoctorButton() {
    var live = document.getElementById("noria-live-doctor-choice");
    if (!live) return;
    var enabled = state.liveDoctorStatusLoaded && state.liveDoctorAvailable && emailValid();
    live.disabled = !enabled;
    live.style.background = enabled ? "#087f8c" : "#d7dde3";
    live.style.borderColor = enabled ? "#087f8c" : "#c8cfd7";
    live.style.color = enabled ? "#ffffff" : "#667085";
    live.style.opacity = "1";
    var message = document.getElementById("noria-live-doctor-availability");
    if (message) message.textContent = state.liveDoctorStatusLoaded && !state.liveDoctorAvailable ? (state.liveDoctorMessage || "Live doctor consultations are temporarily unavailable. Please leave your email and we will contact you as soon as possible.") : "";
  }

  function render() {
    if (state.submitted) { renderSuccess(); return; }
    root.innerHTML = "";

    var errBox = document.createElement("div");
    errBox.id = "noria-accueil-errors";
    root.appendChild(errBox);

    var hasGoogle = !!CFG.google_client_id;
    var hasWa = !!(CFG.whatsapp_number && String(CFG.whatsapp_number).replace(/[^0-9]/g, ""));

    if (hasGoogle) {
      var dual = document.createElement("div");
      dual.className = "noria-accueil-dual";
      var gWrap = document.createElement("div");
      gWrap.className = "noria-accueil-gbtn";
      dual.appendChild(gWrap);
      root.appendChild(dual);
      if (hasGoogle) initGoogle(gWrap); else gWrap.style.display = "none";

      var divider = document.createElement("div");
      divider.className = "noria-accueil-divider";
      var sp = document.createElement("span");
      sp.textContent = "or enter your email below";
      divider.appendChild(sp);
      root.appendChild(divider);
    }

    if (state.googleEmail) {
      var note = document.createElement("div");
      note.className = "noria-accueil-gnote";
      note.textContent = "Signed in as " + state.googleEmail + ". You can add details below, all optional.";
      root.appendChild(note);
    }

    // Required, email
    root.appendChild(field("email", "Email", "email", true));

    root.appendChild(carePathChooser());

    // Required, main reason
    root.appendChild(selectField("category", "What is the main reason for your request", getC02Choices(), true));

    // Optional, pain intensity, right under the main reason
    root.appendChild(scaleField("pain", "Current pain intensity (optional)"));

    // Optional, symptom duration
    root.appendChild(selectField("duration", "How long have you had these symptoms (optional)",
      ["Less than a month", "1 to 3 months", "3 to 6 months", "6 to 12 months", "More than 12 months"], false));

    // Optional, first and last name
    var row1 = rowWrap();
    row1.appendChild(field("first_name", "First name (optional)", "text", false));
    row1.appendChild(field("last_name", "Last name (optional)", "text", false));
    root.appendChild(row1);

    // Optional, phone and country
    var row2 = rowWrap();
    row2.appendChild(field("phone", "Phone (optional)", "tel", false));
    row2.appendChild(selectField("country", "Country (optional)", COUNTRIES, false));
    root.appendChild(row2);

    // Optional and discrete, referral code for business partners.
    var refField = field("referrer", "Referral code (optional)", "text", false);
    refField.classList.add("noria-accueil-referrer");
    root.appendChild(refField);

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "noria-accueil-submit";
    btn.textContent = "Get an expert medical opinion";
    btn.addEventListener("click", submit);
    root.appendChild(btn);
  }

  function rowWrap() {
    var d = document.createElement("div");
    d.className = "noria-accueil-row";
    return d;
  }

  function labelFor(id, text, required) {
    var lab = document.createElement("label");
    lab.className = "noria-accueil-label";
    lab.htmlFor = "f-" + id;
    lab.textContent = text;
    if (required) {
      var r = document.createElement("span");
      r.className = "noria-accueil-req";
      r.textContent = "*";
      lab.appendChild(r);
    }
    return lab;
  }

  function field(id, label, type, required) {
    var wrap = document.createElement("div");
    wrap.className = "noria-accueil-field";
    wrap.appendChild(labelFor(id, label, required));
    var inp = document.createElement("input");
    inp.type = type;
    inp.id = "f-" + id;
    inp.className = "noria-accueil-input";
    if (state.answers[id]) inp.value = state.answers[id];
    inp.addEventListener("input", function (e) {
      state.answers[id] = e.target.value;
      markStarted();
      scheduleCrmSync();
      if (id === "email") updateLiveDoctorButton();
    });
    wrap.appendChild(inp);
    return wrap;
  }

  function selectField(id, label, options, required) {
    var wrap = document.createElement("div");
    wrap.className = "noria-accueil-field";
    wrap.appendChild(labelFor(id, label, required));
    var sel = document.createElement("select");
    sel.id = "f-" + id;
    sel.className = "noria-accueil-select";
    var ph = document.createElement("option");
    ph.value = "";
    ph.textContent = "Select";
    sel.appendChild(ph);
    options.forEach(function (opt) {
      var o = document.createElement("option");
      o.value = opt;
      o.textContent = opt;
      if (state.answers[id] === opt) o.selected = true;
      sel.appendChild(o);
    });
    sel.addEventListener("change", function (e) {
      state.answers[id] = e.target.value;
      markStarted();
      scheduleCrmSync({ immediate: true });
    });
    wrap.appendChild(sel);
    return wrap;
  }

  function scaleField(id, label) {
    var wrap = document.createElement("div");
    wrap.className = "noria-accueil-field";
    wrap.appendChild(labelFor(id, label, false));
    var track2 = document.createElement("div");
    track2.className = "noria-accueil-scale";
    for (var i = 0; i <= 10; i++) {
      (function (val) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "noria-accueil-scale-btn";
        b.textContent = val;
        if (state.answers[id] !== undefined && parseInt(state.answers[id], 10) === val) {
          b.classList.add("is-selected");
        }
        b.addEventListener("click", function () {
          track2.querySelectorAll(".noria-accueil-scale-btn").forEach(function (x) {
            x.classList.remove("is-selected");
          });
          b.classList.add("is-selected");
          state.answers[id] = val;
          markStarted();
          scheduleCrmSync({ immediate: true });
        });
        track2.appendChild(b);
      })(i);
    }
    wrap.appendChild(track2);
    var leg = document.createElement("div");
    leg.className = "noria-accueil-scale-legend";
    var l1 = document.createElement("span");
    l1.textContent = "0, no pain";
    var l2 = document.createElement("span");
    l2.textContent = "10, worst pain";
    leg.appendChild(l1);
    leg.appendChild(l2);
    wrap.appendChild(leg);
    return wrap;
  }

  /* ----------------------------------------------------------------
     Enregistrement progressif dans le CRM. Des qu'un email valide est
     saisi, ou fourni par Google, le prospect existe dans SuiteCRM, et
     chaque changement met a jour la meme ligne, dedoublonnee par session.
     hub@ n'est notifie qu'a la creation et a l'envoi final, jamais a
     chaque frappe.
  ---------------------------------------------------------------- */
  var sync = { timer: null, inFlight: false, pending: false, lastSig: null };

  function emailValid() {
    var e = (state.answers.email || "").trim();
    return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e);
  }

  function currentSig() {
    var a = state.answers;
    return [a.email || "", a.category || "", a.first_name || "", a.last_name || "",
      a.phone || "", a.country || "", a.duration || "",
      (a.pain !== undefined ? a.pain : ""), a.referrer || ""].join("|");
  }

  function scheduleCrmSync(opts) {
    opts = opts || {};
    if (!emailValid()) return;          // pas de fiche CRM tant qu'il n'y a pas d'email
    if (state.submitted) return;
    if (opts.immediate) {
      if (sync.timer) { clearTimeout(sync.timer); sync.timer = null; }
      doCrmSync(opts);
    } else {
      if (sync.timer) clearTimeout(sync.timer);
      sync.timer = setTimeout(function () { doCrmSync(opts); }, 700);
    }
  }

  function doCrmSync(opts) {
    opts = opts || {};
    var sig = currentSig();
    if (!opts.force && sig === sync.lastSig) return;    // rien de nouveau a enregistrer
    if (sync.inFlight) { sync.pending = true; return; }
    sync.inFlight = true;
    var payload = buildPayload();                        // event, form
    fetch(CFG.intake_url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      mode: "cors"
    })
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        try { var d = JSON.parse(txt); if (d && d.crm_id) state.crmId = d.crm_id; } catch (e) {}
        sync.lastSig = sig; track("crm_sync", null);
      })
      .catch(function (e) { track("crm_sync_error", { http_error: String(e && e.message || e) }); })
      .then(function () {
        sync.inFlight = false;
        if (sync.pending) { sync.pending = false; doCrmSync({}); }
      });
  }

  function validate() {
    var errs = [];
    var required = [["email", "Email"], ["category", "Main reason"]];
    required.forEach(function (pair) {
      var v = state.answers[pair[0]];
      if (!v || String(v).trim() === "") errs.push(pair);
    });
    var em = state.answers.email || "";
    if (em && em.indexOf("@") < 1) errs.push(["email", "Email, invalid format"]);
    return errs;
  }

  function submit() {
    var errs = validate();
    var errBox = document.getElementById("noria-accueil-errors");
    errBox.innerHTML = "";
    document.querySelectorAll(".has-error").forEach(function (e) { e.classList.remove("has-error"); });
    if (errs.length) {
      track("form_error", { missing: errs.map(function (e) { return e[0]; }).join(",") });
      var box = document.createElement("div");
      box.className = "noria-accueil-error";
      box.innerHTML = "<strong>Please complete, </strong>" +
        errs.map(function (e) { return e[1]; }).join(", ") + ".";
      errBox.appendChild(box);
      errs.forEach(function (e) {
        var el = document.getElementById("f-" + e[0]);
        if (el) el.classList.add("has-error");
      });
      window.scrollTo({ top: root.offsetTop - 40, behavior: "smooth" });
      return;
    }

    var btn = root.querySelector(".noria-accueil-submit");
    if (btn) { btn.disabled = true; btn.textContent = "Sending."; }

    if (sync.timer) { clearTimeout(sync.timer); sync.timer = null; }

    var payload = buildPayload();
    payload.notify = true;             // envoi final, hub@ recoit la fiche complete
    payload.notify_reason = "submit";

    fetch(CFG.intake_url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      mode: "cors"
    })
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.text();
      })
      .then(function (txt) {
        var data = {};
        try { data = JSON.parse(txt); } catch (e) {}
        state.submissionRef = data.reference || payload.reference;
        if (data.crm_id) state.crmId = data.crm_id;
        state.submitted = true;
        TRACK.submitted = true;
        track("form_submit", { reference: state.submissionRef });
        renderSuccess();
      })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.textContent = "Get an expert medical opinion"; }
        track("form_submit_error", { http_error: String(err && err.message || err) });
        var errBox2 = document.getElementById("noria-accueil-errors");
        var box = document.createElement("div");
        box.className = "noria-accueil-error";
        box.innerHTML = "<strong>Sending error.</strong> Please try again, or email us at hub@noriahealth.com.";
        errBox2.appendChild(box);
        console.error(err);
      });
  }

  function buildPayload() {
    var c02 = state.answers.category || null;
    var module = (state.form && state.form.c02_to_module && state.form.c02_to_module[c02]) || null;
    return {
      event: "form",
      stage: "etage1_accueil",
      reference: getReference(),
      session_id: getSessionId(),
      submitted_at: new Date().toISOString(),
      crm_id: state.crmId || null,
      referrer: state.answers.referrer || null,
      source: {
        shop_domain: CFG.shop_domain,
        landing_page: UTM.landing_page,
        referrer: UTM.referrer
      },
      utm: {
        source: UTM.utm_source,
        medium: UTM.utm_medium,
        campaign: UTM.utm_campaign,
        content: UTM.utm_content,
        term: UTM.utm_term
      },
      lead: {
        first_name: state.answers.first_name || null,
        last_name: state.answers.last_name || null,
        email: state.answers.email || null,
        phone: state.answers.phone || null,
        country: state.answers.country || null,
        shopify_customer_id: (CFG.logged_in_customer && CFG.logged_in_customer.id) || null
      },
      qualification: {
        category_c02: c02,
        module_pressenti: module,
        duration: state.answers.duration || null,
        pain_level: (state.answers.pain !== undefined) ? state.answers.pain : null,
        care_path: state.carePath || "assessment"
      },
      etape2_path: CFG.etape2_path
    };
  }

  function renderSuccess() {
    root.innerHTML = "";
    var box = document.createElement("div");
    box.className = "noria-accueil-success";
    box.innerHTML = ""
      + "<h3>Your request has been received.</h3>"
      + "<p>Our team will contact you shortly to guide you through the next steps.</p>"
      + "<p>Please keep your reference number for any follow-up.</p>"
      + "<div class=\"noria-accueil-ref\">" + escapeHtml(state.submissionRef || getReference()) + "</div>";
    root.appendChild(box);
    window.scrollTo({ top: root.offsetTop - 60, behavior: "smooth" });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
})();
